import { Search } from '@mui/icons-material'
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material'

import useStyles from '../index.styles'

interface INoResultItemProps {
  searchQuery: string
  onClick: () => void
}

const NoResultItem = ({ searchQuery, onClick }: INoResultItemProps) => {
  const classes = useStyles
  return (
    <MenuItem onClick={onClick} tabIndex={0} data-testid="search-result-item">
      <ListItemIcon sx={classes.searchMenuItemIcon}>
        <Search />
      </ListItemIcon>
      <ListItemText
        primary={`${searchQuery.toLowerCase()} – search accounts, people, and more`}
        className="fs-exclude"
        slotProps={{
          primary: {
            variant: 'subtitle1',
          },
        }}
      />
    </MenuItem>
  )
}

export default NoResultItem
